import React, { createContext, useContext, useState, ReactNode } from "react";
import {
  WhiteLabelLeadData,
  WhiteLabelLeadPermissions,
} from "@lib/types/Context";

interface WhiteLabelLeadContextType {
  // Lead data
  lead: WhiteLabelLeadData | null;
  setLead: (lead: WhiteLabelLeadData | null) => void;

  // Permissions
  permissions: WhiteLabelLeadPermissions;

  // UI State
  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;

  // Methods
  refreshLeadData: () => Promise<void>;
  updateLeadPermissions: (
    permissions: Partial<WhiteLabelLeadPermissions>,
  ) => void;
  getWhiteLabelCustomerInfo: () => Promise<any>; // WhiteLabel customer bilgilerini getir
}

const WhiteLabelLeadContext = createContext<
  WhiteLabelLeadContextType | undefined
>(undefined);

interface WhiteLabelLeadProviderProps {
  children: ReactNode;
  leadId?: string;
  whiteLabelCustomerId?: string;
}

export const WhiteLabelLeadProvider: React.FC<WhiteLabelLeadProviderProps> = ({
  children,
  leadId,
  whiteLabelCustomerId,
}) => {
  const [lead, setLead] = useState<WhiteLabelLeadData | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const defaultPermissions: WhiteLabelLeadPermissions = {
    canViewBlockchainPayments: true,
    canViewWalletPool: true,
    canManageWalletAddresses: true,
    canViewTransactions: true,
  };

  const refreshLeadData = async () => {
    if (!leadId) return;

    setIsLoading(true);
    try {
      // API call to fetch lead data
      // const response = await fetchLeadData(leadId);
      // setLead(response.data);
    } catch (error) {
      console.error("Error fetching lead data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const updateLeadPermissions = (
    newPermissions: Partial<WhiteLabelLeadPermissions>,
  ) => {
    if (lead) {
      setLead({
        ...lead,
        permissions: {
          ...lead.permissions,
          ...newPermissions,
        },
      });
    }
  };

  const getWhiteLabelCustomerInfo = async () => {
    if (!whiteLabelCustomerId) return null;

    try {
      // API call to fetch white label customer info
      // const response = await fetchWhiteLabelCustomerData(whiteLabelCustomerId);
      // return response.data;
    } catch (error) {
      console.error("Error fetching white label customer info:", error);
      return null;
    }
  };

  const value: WhiteLabelLeadContextType = {
    lead,
    setLead,
    permissions: lead?.permissions || defaultPermissions,
    isLoading,
    setIsLoading,
    refreshLeadData,
    updateLeadPermissions,
    getWhiteLabelCustomerInfo,
  };

  return (
    <WhiteLabelLeadContext.Provider value={value}>
      {children}
    </WhiteLabelLeadContext.Provider>
  );
};

export const useWhiteLabelLead = (): WhiteLabelLeadContextType => {
  const context = useContext(WhiteLabelLeadContext);
  if (context === undefined) {
    throw new Error(
      "useWhiteLabelLead must be used within a WhiteLabelLeadProvider",
    );
  }
  return context;
};
